import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as C1 } from "./assets/c_1.svg";
import { ReactComponent as C2 } from "./assets/c_2.svg";
import { ReactComponent as C3 } from "./assets/c_3.svg";
import { ReactComponent as C4 } from "./assets/c_4.svg";
import { ReactComponent as C5 } from "./assets/c_5.svg";
import { ReactComponent as C6 } from "./assets/c_6.svg";
import { ReactComponent as C7 } from "./assets/c_7.svg";

const clients = [
  <C1 key="c1" />,
  <C2 key="c2" />,
  <C3 key="c3" />,
  <C4 key="c4" />,
  <C5 key="c5" />,
  <C6 key="c6" />,
  <C7 key="c7" />,
];

export const ClientsShowcase = () => {
  const { t } = useTranslations();
  return (
    <div>
      <div className="font-secondary px-8 pb-8 text-center text-2xl font-semibold leading-7 text-black">
        {t({
          id: "subscription-plans-dialog.clients-showcase-title",
          defaultMessage:
            "Over 1000+ businesses, from startups to industry leaders use Jugl",
        })}
      </div>
      <div className="overflow-hidden">
        <div
          className="flex gap-[11px]"
          style={{
            animation: "marquee 20s linear infinite",
            width: "max-content",
          }}
        >
          {clients.map((client, idx) => (
            <React.Fragment key={`a-${+idx}`}>{client}</React.Fragment>
          ))}
          {clients.map((client, idx) => (
            <React.Fragment key={`b-${+idx}`}>{client}</React.Fragment>
          ))}
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};
